import React, { useState } from "react";

import {
  ComposedChart,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Scatter,
  ResponsiveContainer
} from "recharts";

const Hightchart2 = prop => {
  // Check if this is multi-series data (S2 with multiple types)
  const isMultiSeries =
    prop.dataHigh &&
    prop.dataHigh.length > 0 &&
    (prop.dataHigh[0]["Other Income_cumulative"] ||
      prop.dataHigh[0]["Project Type 2_cumulative"]);

  return (
    <React.Fragment>
      <ResponsiveContainer width="100%" height={250}>
        {prop.order == 1
          ? <ComposedChart
              width={500}
              height={400}
              data={prop.dataHigh}
              margin={{
                top: 10,
                right: 0,
                bottom: 40,
                left: -10
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis
                dataKey="name"
                scale=""
                interval={0}
                padding={{ left: 45, right: 20 }}
              />

              {prop.datatype == "unlimit"
                ? <YAxis domain={[0, "dataMax + 30"]} allowDecimals={false} />
                : <YAxis domain={[0, "dataMax + 5"]} allowDecimals={false} />}

              <Tooltip />
              {/* <Legend /> */}
              {/* <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" /> */}

              {!isMultiSeries && (
                <Bar
                  name="ข้อมูลของเดือน"
                  dataKey="data_in_Month"
                  barSize={20}
                  fill="#BED7DC"
                />
              )}

              {isMultiSeries ? (
  <>
    <Bar
      name="รายได้นอกเหนือจากทุนวิจัย"
      dataKey="Other Income_monthly"
      barSize={15}
      fill="#FFB3B3"
    />
    <Bar
      name="ทุนบริการวิชาการ"
      dataKey="Project Type 2_monthly"
      barSize={15}
      fill="#B3E5FC"
    />
    <Line
      name="รายได้นอกเหนือจากทุนวิจัย (สะสม)"
      type="monotone"
      dataKey="Other Income_cumulative"
      stroke="#FF6B6B"
      strokeWidth={3}
    />
    <Line
      name="ทุนบริการวิชาการ (สะสม)"
      type="monotone"
      dataKey="Project Type 2_cumulative"
      stroke="#4ECDC4"
      strokeWidth={3}
    />
  </>
) : (
                <Line
                  name="ผลรวมสะสม"
                  type="monotone"
                  dataKey="data"
                  stroke="#6AD4DD"
                  strokeWidth={3}
                />
              )}

              <Line
                type="monotone"
                dataKey="goal"
                stroke="#9BCF53"
                strokeDasharray="3 3"
                strokeWidth={2}
              />
              {/* <Scatter dataKey="cnt" fill="red" /> */}
            </ComposedChart>
          : <ComposedChart
              width={500}
              height={400}
              data={prop.dataHigh}
              margin={{
                top: 10,
                right: 0,
                bottom: 40,
                left: -30
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <XAxis dataKey="name" scale="band" />
              <YAxis domain={["auto", 100]} allowDecimals={false} />
              <Tooltip />
              {/* <Legend /> */}
              {/* <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" /> */}

              <Line
                name="ผลรวมสะสม"
                type="monotone"
                dataKey="data"
                stroke="#6AD4DD"
                strokeWidth={3}
              />
              <Line
                type="monotone"
                dataKey="goal"
                stroke="#9BCF53"
                strokeDasharray="3 3"
                strokeWidth={2}
              />
              {/* <Scatter dataKey="cnt" fill="red" /> */}
            </ComposedChart>}
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Hightchart2;
